import { ViewportSizes } from '@syconium/little-miss-figgy'

export interface SlideItemPopperProps {
  image: string
  maxWidth?: string
  bottom?: string
  width?: string
  top?: string
  left?: string
  right?: string
  viewport?: ViewportSizes
}

export interface SlideItemProps {
  title: string
  subTitle: string
  image: string
  popper?: SlideItemPopperProps
}

export const slideItems: SlideItemProps[] = [
  {
    title: 'Insider Access',
    subTitle: 'Get early access to every drop and shop app-only releases',
    image: 'https://cdn.shopify.com/s/files/1/0139/8942/files/app_LP.png?v=1671470674',
    popper: {
      image:
        'https://cdn.shopify.com/s/files/1/0139/8942/files/Frame_3369_1327f8e0-33b5-4516-abcc-b6d5f8adb225.png?v=1676317582',
      maxWidth: '30%',
      top: '13%',
      left: '22%',
    },
  },
  {
    title: 'Explore Past Colors',
    subTitle: 'Compare colors and vote to bring back your favorites',
    image: 'https://cdn.shopify.com/s/files/1/0139/8942/files/Group_2458.png?v=1666975178',
    popper: {
      image: 'https://cdn.shopify.com/s/files/1/0139/8942/files/Frame_3392.png?v=1661236609',
      maxWidth: '42%',
      top: '27%',
      left: '15%',
    },
  },
  {
    title: 'Create Your Wish List',
    subTitle: 'Save and share your favorite products — shopping made easy',
    image: 'https://cdn.shopify.com/s/files/1/0139/8942/files/6.1._Favorites.png?v=1663829072',
    popper: {
      image: 'https://cdn.shopify.com/s/files/1/0139/8942/files/Frame_3406.png?v=1661236607',
      maxWidth: '40%',
      top: '27%',
      right: '-4%',
    },
  },
  {
    title: 'Personalized Shopping',
    subTitle: 'Store your details, get customized product recs, tracking updates and more',
    image:
      'https://cdn.shopify.com/s/files/1/0139/8942/files/Account_-_Signed_In_Custom_Avatar_3.png?v=1666993520',
    popper: {
      image: 'https://cdn.shopify.com/s/files/1/0139/8942/files/Group_2252.png?v=1663221808',
      width: '109%',
      bottom: '13%',
      left: '4%',
      viewport: ViewportSizes.small,
    },
  },
]
